<script lang="ts">
	import { Card } from "@hitit/new_ui";

	import EditBirth from "@hitit/hub/src/v7/components/profile/EditBirthDay.svelte";
	import EditName from "@hitit/hub/src/v7/components/profile/EditName.svelte";
	import EditProfileImage from "./EditProfileImage.svelte";
	import EditEmail from "./EditEmail.svelte";
	import EditPhone from "./EditPhone.svelte";
	import EditPassword from "./EditPassword.svelte";

	//Utils

	//UI
	//Utils
	//Types
	import type { ProfileData, UserData } from "@hitit/api";
	//Props
	export let user: UserData;
	export let profile: ProfileData;
	//Constants
	//Variables
	//Functions
	//Do
</script>

<Card noPadding>
	<div class="contents-container">
		<div class="profile-image-container">
			<EditProfileImage userId={user.id} />
		</div>
		<div class="card-container">
			<EditName bind:user userId={user.id} bind:profile/>
			<EditEmail bind:username={user.username} bind:user bind:profile />
			<EditPassword user={user} bind:profile/>
			<EditPhone bind:profile user={user} />
			<EditBirth bind:profile userId={user.id} />
		</div>
	</div>
</Card>

<style lang="scss">
	@import "../../../variables.scss";
	.contents-container {
		display: flex;
		flex-direction: column;
		width: 100%;
		height: 100%;
		align-items: center;
		.card-container {
			display: flex;
			flex-direction: column;
			gap: 20px;
			padding: 20px 0px;
			width: 100%;
			border-radius: 5px;
			box-sizing: border-box;
		}
		.profile-image-container {
			display: flex;
			justify-content: center;
			align-items: center;
			width: 100%;
			height: 250px;
			margin-top: 32px;
			margin-bottom: 20px;
		}
	}

	@include DesktopSize {
		.contents-container {
			.card-container {
				max-width: 100%;
				padding: 20px 0px;
				gap: 20px;
			}
			.profile-image-container {
				height: 350px;
				margin-top: 30px;
				margin-bottom: 50px;
			}
		}
	}

</style>
